import * as ui from './ui';
import * as form from './form';
import * as common from './common';

export default { common, ui, form };